import apiService from '@/state/services/Api'

const profile = {
  namespaced: true,
  state: {
    cached: []
  },
  getters: {
    getLocale(state) {
      return state.locale
    }
  },
  actions: {
    update({ state, commit, rootState }, { id, name }) {
      return apiService.patch(`users/${id}/`, { name }).then((data) => {
        commit('auth/UPDATE_CURRENT_USER', { name }, { root: true })
        return data
      })
    },

    changePassword({ state, commit, rootState }, payload) {
      return apiService.post(`users/change_password/`, payload)
    }
  }
}

export default profile
